import * as React from 'react'
import * as ReactDOM from 'react-dom'
import SystemDialog from '../tools/SystemDialog';

const SystemShowDialogPlaceHolder = "SystemShowDialogPlaceHolder";
export const ShowDialogContainer = () => <div style={{ zIndex: 999999 }} id={SystemShowDialogPlaceHolder} />;

export const showConfirm = async (message?: string, title: string = "Please Confirm") => await showModal(title, message, 0, true, true, false, false, false);
export const showSuccess = async (message?: string, title: string = "Success") => await showModal(title, message, 0, false, false, false, false, true);
export const showError = async (message?: string, title: string = "Error") => await showModal(title, message, 0, false, false, false, false, true);
export const showInfo = async (message?: string, title: string = "Information") => await showModal(title, message, 0, false, false, false, false, true);

export const showModal = (title?: string, message?: string, mode: number = 0,
    showYes: boolean = true, showNo: boolean = true, showCancel: boolean = false, showAbort: boolean = false, showClose: boolean=false): Promise<boolean> => {
    var rootElement= document.getElementById(SystemShowDialogPlaceHolder)
    var dialogPlace = document.createElement("div");
    rootElement.appendChild(dialogPlace);

    return new Promise<boolean>((resolve) => {

        const onYes = () => {
            resolve(true);
            ReactDOM.render(undefined, dialogPlace);
            dialogPlace.remove();
        };



        const onNo = () => {
            resolve(false);
            ReactDOM.render(undefined, dialogPlace);
            dialogPlace.remove();
        };

        const CustomTitleBar = () => {
            return (
                <div style={{backgroundColor: mode == 0 ? "rgb(241, 245, 248)" : "rgb(255, 99, 88)" }} >
                    {title}
                </div>
            );
        };

        

        ReactDOM.render(
            <SystemDialog showYes={showYes} showNo={showNo} showAbort={showAbort} showCancel={showCancel} showClose={showClose} title={<CustomTitleBar />} visible={true} message={message} onYes={onYes} onNo={onNo} onCancel={onNo} onClose={onNo} onAbort={onNo} />,
            dialogPlace
        );
    });
}

